
import React from "react";

interface CourseArraySectionProps {
  items?: string[] | null;
}

const CourseArraySection = ({ items }: CourseArraySectionProps) =>
  items && items.length > 0 ? (
    <ul className="list-disc ml-6 space-y-1">
      {items.map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>
  ) : (
    <span className="text-gray-500">-</span>
  );

export default CourseArraySection;
